import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { SessionService } from '../../../services/session-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { EligibilitySession } from '../../../models/eligibility-session';
import { SnackBarService } from '../../../services/snack-bar-service';

@Component({
  selector: 'app-edit-session-name-dialog-component',
  imports: [MatDialogModule, MatInputModule, MatButtonModule, FormsModule],
  templateUrl: './edit-session-name-dialog-component.html'
})
export class EditSessionNameDialogComponent {
  session: EligibilitySession;

  constructor(
    private readonly sessionService: SessionService,
    private readonly snackBar: SnackBarService,
    private dialogRef: MatDialogRef<EditSessionNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {
    this.session = data.session;
  }

  updateSession() {
    this.sessionService.updateSession(this.session.code, {name: this.session.name}).subscribe({
      next: (session) => {
        this.session = session;
        this.snackBar.success("Session modifiée !");
        this.dialogRef.close(session);
      },
      error: () => {
        this.snackBar.error("Erreur rencontrée lors de la modification.");
      }
    });
  }
}
